import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
}

/**
 * Resolve UUID keys in custom_inputs to human-readable labels
 * using the product's CustomInputDefinition[] JSONB.
 * For keys that don't match any definition, keeps the original key.
 */
export function resolveCustomInputLabels(
  customInputs: Record<string, string> | null,
  definitions: unknown
): Record<string, string> | null {
  if (!customInputs) return null

  const labelMap = new Map<string, string>()
  if (Array.isArray(definitions)) {
    for (const def of definitions) {
      if (def && typeof def === 'object' && typeof def.id === 'string' && typeof def.label === 'string') {
        labelMap.set(def.id, def.label)
      }
    }
  }

  if (labelMap.size === 0) return customInputs

  // Check if any key looks like a UUID (contains only hex + hyphens)
  const hasUuidKeys = Object.keys(customInputs).some(k => /^[0-9a-f-]{8,}$/i.test(k))
  if (!hasUuidKeys) return customInputs

  const resolved: Record<string, string> = {}
  for (const [key, value] of Object.entries(customInputs)) {
    resolved[labelMap.get(key) || key] = value
  }
  return resolved
}
